import React, {forwardRef, memo} from 'react';
import styled from 'styled-components';

import {fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {ellipsis} from '../../../../../libs/shared/ui/src/styles/mixins';
import {PaletteColorsEnum} from '../../../../../libs/shared/ui/src/styles/paletteModel';

/*
 * Props.
 */

export interface EmailInviteTokenProps {
  email: string;
  isSelected: boolean;
  hasError: boolean;
}

/*
 * Style.
 */

const StyledWrapperDiv = styled.div`
  margin: 4px 2px;
`;

interface TokenStyleProps {
  $color: PaletteColorsEnum;
  $isSelected: boolean;
}
const StyledTokenDiv = styled.div<TokenStyleProps>`
  user-select: none;
  padding: 4px;

  border-radius: 4px;
  color: ${(p) => p.theme.palette[p.$color].shade40};
  font-weight: ${fontWeights.medium};
  background-color: ${(p) =>
    p.$isSelected ? p.theme.palette[p.$color].shade30 : p.theme.palette[p.$color].shade20};

  &:hover {
    background-color: ${(p) => p.theme.palette[p.$color].shade30};
  }

  max-width: 300px;
  ${ellipsis()};
`;

/*
 * Component.
 */

/** Used in the invite teammate popover to render emails. */
export const EmailInviteToken = memo(
  forwardRef<HTMLDivElement, EmailInviteTokenProps>((props, ref) => {
    const color = props.hasError ? PaletteColorsEnum.RED : PaletteColorsEnum.BLUE;

    return (
      <StyledWrapperDiv ref={ref} data-testid="email-invite-token">
        <StyledTokenDiv $color={color} $isSelected={props.isSelected}>
          {props.email}
        </StyledTokenDiv>
      </StyledWrapperDiv>
    );
  }),
);
